module.exports = __webpack_public_path__ + "img/1529732813.45dcf00a.jpg";